import type { DocumentMode } from '@root/@types/types';
import { getDocumentMode } from '@root/src/helpers/getDocumentMode';
import { useLanguage } from '@root/src/language';

interface DocumentStatusUpdateProps {
  status: string;
}

export const formatStatus = (status: string) => {
  if (status === 'FIRM_ORDER') {
    return 'firm order';
  }

  return status.toLocaleLowerCase();
};

export const DocumentStatusUpdate = ({ status = '' }: DocumentStatusUpdateProps) => {
  const { mode } = getDocumentMode();
  const { getContent } = useLanguage({ prefix: mode as Exclude<DocumentMode, 'other'> });
  const lowerCase = formatStatus(status);
  return (
    <div className="text-sm">
      <h3 className="text-info-700 self-center leading-relaxed font-medium">
        Status updated to <span className="capitalize">{lowerCase}</span>
      </h3>
      <p className="text-info-400">{getContent(`notifications.statusUpdate.${lowerCase}`)}</p>
    </div>
  );
};
